import React from 'react';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';
import { InternalGrid, Text } from '@paygreen/paygreen-ui';
import { ErrorBoundary } from '../../components';

const SubscriptionSuccessMessage = ({ newUser }) => {
    const {
        contact: { email },
        user: { firstname, lastname },
    } = newUser;

    const publicName = firstname + ' ' + lastname;

    return (
        <ErrorBoundary>
            <InternalGrid
                justifyContent="center"
                alignItems="center"
                childrenMarginBottom="md"
                childrenMarginTop="md"
                childrenMarginLateral="md"
            >
                <Text
                    textSize="md"
                    align="center"
                    colorPallet="theme"
                    htmlTag="strong"
                >
                    <span role="img" aria-label="tree emoji">
                        🌳
                    </span>

                    {/* Trans component will map all children as an array to build proper translations. content here is needed only to match content and index in json translation files */}
                    <Trans i18nKey="subscription.success.thankYou">
                        ...
                        <Text
                            colorPallet="theme"
                            htmlTag="strong"
                            textSize="md"
                        >
                            {{
                                publicName,
                            }}
                            ...
                        </Text>
                    </Trans>

                    <span role="img" aria-label="leaves emoji">
                        🌱
                    </span>
                </Text>

                <Text textSize="sm" align="center">
                    <Trans i18nKey="subscription.success.sentence">
                        ...
                        <Text textSize="sm" htmlTag="strong">
                            {{
                                email,
                            }}
                            ...
                        </Text>
                    </Trans>
                </Text>
            </InternalGrid>
        </ErrorBoundary>
    );
};

SubscriptionSuccessMessage.propTypes = {
    newUser: PropTypes.object.isRequired,
};

export default withTranslation('common')(SubscriptionSuccessMessage);
